import React from 'react';
import '../../css/ytModal.css';

const Modal = (props) => {
    let url = props.show ? 'https://www.youtube.com/watch?v=OgtDdYtK4GA': ''
    return (
        <div className='modal-wrapper'
                style={{
                    display: props.show ? 'block' : 'none',
                    opacity: props.show ? '1' : '0'
                }}>
            <div>
                <div className='modal-header'>
                    <h2>Responsive Elevator Pitch</h2>
                    <span className='close-modal-btn' onClick={props.close}>x</span>
                </div>
                <div className='modal-body'>
                    <iframe
                        className='video-scr' src={url}
                        allow='autoplay : encrypted-media '
                        title='video'
                        style={{
                            display: props.show ? 'block' : 'none',
                            opacity: props.show ? '1' : '0'
                        }}
                    />
                </div>
                <div className='modal-footer'>
                    <p>Subscribe to my Youtube Channel</p>
                </div>
            </div>
        </div>
    )
}

export default Modal;